export default "__VITE_ASSET__BWX8sW$q__"